import { type Node as PMNode, Fragment } from "@tiptap/pm/model"

/**
 * Returns the first descendant satisfying predicate together with its position,
 * or null if none is found.
 */
export function findNodeAndPos(
  doc: PMNode,
  predicate: (node: PMNode) => boolean,
): { node: PMNode; pos: number } | null {
  let found: { node: PMNode; pos: number } | null = null
  doc.descendants((node, pos) => {
    if (found !== null) return false
    if (predicate(node)) {
      found = { node, pos }
      return false
    }
    return true
  })
  return found
}

/**
 * Replaces each node in fragment's subtree with the result of calling replace on that node
 * (followed by recursing into the node's content). Return null to remove a node entirely.
 */
export function replaceNodes(
  fragment: Fragment,
  replace: (node: PMNode) => PMNode | null,
): Fragment {
  let hasChange = false
  const newChildren: PMNode[] = []
  for (let i = 0; i < fragment.childCount; i++) {
    const child = fragment.child(i)
    let newChild = replace(child)
    if (newChild !== null) {
      const newChildContent = replaceNodes(child.content, replace)
      if (newChildContent !== child.content) {
        newChild = newChild.copy(newChildContent)
      }
      newChildren.push(newChild)
    }
    if (newChild !== child) hasChange = true
  }

  if (hasChange) return Fragment.fromArray(newChildren)
  else return fragment
}
